import { Module } from '@nestjs/common';
import { winstonConfig } from '../common/logger/winston.config';
import { PrismaModule } from '../prisma/prisma.module';
import { RendicionesController } from './rendiciones.controller';
import { RendicionesService } from './rendiciones.service';

@Module({
  imports: [PrismaModule],
  controllers: [RendicionesController],
  providers: [RendicionesService],
  exports: [RendicionesService],
})
export class RendicionesModule {}
